import { render, staticRenderFns } from "./StatTile.vue?vue&type=template&id=f137694a&scoped=true"
import script from "./StatTile.vue?vue&type=script&lang=js"
export * from "./StatTile.vue?vue&type=script&lang=js"
import style0 from "./StatTile.vue?vue&type=style&index=0&id=f137694a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f137694a",
  null
  
)

export default component.exports